import { Activity, Boxes, CircleDollarSign, Coins, TimerReset, TriangleAlert } from "lucide-react";
import { formatCompact, formatDuration, formatMoney, formatNumber } from "./usageFormatters";

function MetricCard({ icon: Icon, label, value, hint, warning }) {
    return (
        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
            <div className="flex items-start justify-between gap-3">
                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">{label}</p>
                    <p className="mt-2 text-2xl font-semibold tracking-tight text-slate-900">{value}</p>
                    {hint && <p className={`mt-1 text-xs ${warning ? "text-amber-600" : "text-slate-500"}`}>{hint}</p>}
                </div>
                <div className="rounded-lg bg-slate-100 p-2.5 text-slate-600"><Icon className="h-5 w-5" /></div>
            </div>
        </div>
    );
}

export default function AIUsageSummary({ summary = {} }) {
    const failureRate = Number(summary.requests || 0) ? (Number(summary.failed_requests || 0) / Number(summary.requests)) * 100 : 0;
    return (
        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-6">
            <MetricCard icon={CircleDollarSign} label="Costo estimado" value={formatMoney(summary.estimated_cost_usd)} hint="Costo del modelo, no débito Emergent" />
            <MetricCard icon={Coins} label="Tokens" value={formatCompact(summary.total_tokens)} hint={`${formatNumber(summary.total_tokens)} totales`} />
            <MetricCard icon={Activity} label="Requests" value={formatCompact(summary.requests)} hint={`${failureRate.toFixed(1)}% con error`} warning={failureRate > 3} />
            <MetricCard icon={Boxes} label="Softwares" value={formatNumber(summary.active_applications)} hint="Con actividad en el período" />
            <MetricCard icon={TimerReset} label="Latencia media" value={formatDuration(summary.avg_duration_ms)} hint="Requests finalizados" />
            <MetricCard icon={TriangleAlert} label="Fallos" value={formatNumber(summary.failed_requests)} hint="Proveedor, timeout o gateway" warning={Number(summary.failed_requests) > 0} />
        </div>
    );
}
